var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502.707 502.707",
    style: {
      enableBackground: "new 0 0 502.707 502.707"
    },
    xmlSpace: "preserve",
    width: "15px",
    height: "15px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M70.971,225.97h-40c0-107.523,87.477-195,195-195v40C140.503,70.97,70.971,140.503,70.971,225.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M140.971,225.97h-40c0-68.925,56.075-125,125-125v40C179.102,140.97,140.971,179.101,140.971,225.97 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00E7F0"
    },
    d: "M331.074,182.624l-44.169-44.169L425.361,0l14.118,12.988c5.997,5.517,58.712,55.2,62.858,100.185 c3.448,37.418-17.99,83.13-36.582,114.89c-25.499,43.561-61.822,89.43-105.041,132.649L256.85,256.848L331.074,182.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00D7DF"
    },
    d: "M138.458,286.903l44.168,44.169l74.224-74.224l103.864,103.864 c-86.254,86.253-180.157,141.989-239.229,141.995c-2.835,0-5.627-0.125-8.31-0.372c-44.985-4.148-94.669-56.862-100.186-62.858 L0.002,425.358L138.458,286.903z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.358c4ac41aed968526b95140497b696c.svg";
export { ForwardRef as ReactComponent };